import { makeStyles } from '@material-ui/core';
import { createStyles, Theme } from '@material-ui/core/styles';
import { colorsPalette } from '../../../theme';

const useStyles = (bgColor = colorsPalette.blue, textColor = colorsPalette.white, textMaxWidth) =>
  makeStyles((theme: Theme) =>
    createStyles({
      categoryLabel: {
        borderRadius: 5,
        background: bgColor,
        padding: '4px 9px 5px',
        display: 'inline-flex',
      },
      categoryTitle: {
        color: textColor,
        fontWeight: 'bold',
        fontSize: 14,
        lineHeight: 1.4,
      },
      withDots: {
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        maxWidth: 100,
        [theme.breakpoints.up('md')]: {
          maxWidth: textMaxWidth || 125,
        },
      },
    }),
  );

export default useStyles;
